import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Card } from 'sa-ui';
import sortBy from 'lodash/sortBy';
import LineTo from 'react-lineto';

import './ReportBarChart.scss';

import Label from './Label';

import * as helpers from './reportHelpers';

// const LIMIT = 5;

const GenericReportBarChart = (props) => {
  const [id] = useState(Math.random());

  function LinesRender() {
    function Lines() {
      return props.series.map((serie) => (
        <LineTo
          from={serie.index}
          to={serie.index + 1}
          borderColor="#555"
          borderWidth="2px"
          // style={{ zIndex: 1 }}
          within={`container-lines-${id}`}
        />
      ));
    }
    const [lines, setLines] = useState(Lines());
    //   useEffect(() => {
    //     let isMounted = true;
    //     function handleResize() {
    //       setLines(Lines());
    //     }
    //     if (isMounted) {
    //       window.addEventListener('resize', handleResize);
    //       window.addEventListener('beforeprint', handleResize);
    //       window.addEventListener('click', handleResize);
    //     }
    //     return () => {
    //       isMounted = false;
    //     };
    //   }, []);
    return lines;
  }

  console.log('props.series', props.series);

  return (
    <Card style={{ width: '100%', overflowX: 'auto', overflowY: 'hidden' }}>
      <div style={{ color: props.titleColor }}>
        <strong>
          <i className="pe-7s-graph1 mr-2" />
          {props.title}
        </strong>
      </div>
      <div className="mt-3">
        <div className="report-bar-chart lines-container">
          {props.series[0].courseAverage || (props.isStudentTRI && props.series[0].average) ? (
            <div>
              <Label TRILabel={props.isStudentTRI} />
              <div
                className={`container-lines-${id}`}
                style={{ position: 'relative', zIndex: 1 }}
              />
            </div>
          ) : (
            ''
          )}
          {props.isStudentTRI &&
            props.series.map((serie) => (
              <div className={`bar-wrapper  ${serie.average ? 'big-bar-wrapper' : ''}`}>
                <div
                  className="value"
                  style={{
                    color: helpers.getColor(parseInt(serie.data / 10)),
                    backgroundColor: 'rgba(255,255,255,0.5)',
                  }}
                >
                  {serie.data}
                </div>
                <div
                  className="bar"
                  style={{
                    height: serie.data / 2,
                    backgroundColor: helpers.getColor(parseInt(serie.data / 10)),
                    width: props.barWidth,
                    maxWidth: props.barWidth,
                  }}
                />
                {serie.average ? (
                  <div>
                    <div
                      className={`point-hitAvg ${serie.index}`}
                      style={{ bottom: (serie.average + 55) / 2 }}
                    />
                  </div>
                ) : (
                  ''
                )}
                <div className="description">{serie.name}</div>
              </div>
            ))}
          {!props.isStudentTRI &&
            props.series.map((serie) => (
              <div className={`bar-wrapper  ${serie.courseAverage ? 'big-bar-wrapper' : ''}`}>
                <div className="value" style={{ color: helpers.getColor(serie.data) }}>
                  {serie.data}%
                </div>
                <div style={{ position: 'relative' }}>
                  <div
                    className="bar"
                    style={{
                      height: serie.data * 3,
                      backgroundColor: helpers.getColor(serie.data),
                      width: props.barWidth,
                      maxWidth: props.barWidth,
                    }}
                  />
                  {serie.courseAverage ? (
                    <div>
                      <div
                        className={`point-hitAvg ${serie.index}`}
                        style={{
                          bottom: serie.courseAverage * 3 - 8,
                          left: '50%',
                          transform: 'translateX(-50%)',
                        }}
                      />
                      <div
                        className="courseAverageLabel"
                        style={{ bottom: serie.courseAverage * 3 - 12, right: '-32px' }}
                      >
                        {serie.courseAverage}%
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                </div>

                <div className="description">{serie.name}</div>
              </div>
            ))}
          {props.series[0].courseAverage || (props.isStudentTRI && props.series[0].average) ? (
            <LinesRender />
          ) : (
            ''
          )}
        </div>
      </div>
    </Card>
  );
};
GenericReportBarChart.propTypes = {};

GenericReportBarChart.defaultProps = {
  series: [],
  title: '',
  barWidth: 20,
};

export default GenericReportBarChart;
